const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const formatExportDate = (date) => {
    const parsed = date ? new Date(date) : new Date();
    const when = Number.isNaN(parsed.getTime()) ? new Date() : parsed;
    const day = String(when.getDate()).padStart(2, "0");
    const month = MONTHS[when.getMonth()];
    const year = String(when.getFullYear()).slice(-2);
    return `${day}${month}${year}`;
};

const cleanFilePart = (value) => String(value ?? "").replace(/[\\/:*?"<>|]/g, "").replace(/\s+/g, " ").trim();

/**
 * Periodontal Chart - 18Oct26 - 123 - SMITH, Jane
 */
export const periodontalExportBaseName = ({ title = "Periodontal Chart", patient, date } = {}) => {
    const when = formatExportDate(date);
    const id = cleanFilePart(patient?.patient_identifier);
    const surname = cleanFilePart(patient?.last_name).toUpperCase();
    const firstName = cleanFilePart(patient?.first_name);
    const person = surname && firstName ? `${surname}, ${firstName}` : surname || firstName;

    return [title, when, id, person].filter(Boolean).join(" - ");
};

export const periodontalExportFileName = (options, extension) => {
    const detail = cleanFilePart(options?.detail);
    const stem = detail ? `${periodontalExportBaseName(options)} - ${detail}` : periodontalExportBaseName(options);
    return extension ? `${stem}.${extension}` : stem;
};
